<script>
import { useAlert } from 'dashboard/composables';
import { emitter } from 'shared/helpers/mitt';

export default {
  props: {
    currentWeekday: {
      type: String,
      default: '',
    },
    bookableTimes: {
      type: Object,
      default: () => {},
    },
    isBlockedIntervals: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedHour: '12',
      selectedMinute: '30',

      // List of hours 0..23
      selectableHours: [...Array(24)].map((_, i) =>
        i.toString().padStart(2, '0')
      ),
      // List of minutes 0..55, step of 5 minutes
      selectableMinutes: Array.from({ length: 12 }, (_, i) =>
        (i * 5).toString().padStart(2, '0')
      ),

      weekdayTimesList: [...this.bookableTimes[this.currentWeekday].horarios],

      errorMessagesList: [
        'Selecione um horário válido',
        'O horário que você tentou adicionar já existe',
      ],
      errorMessage: '',
    };
  },
  methods: {
    showAlert(message) {
      emitter.emit('newToastMessage', message);
    },
    addSelectedTime() {
      const selectedTime = `${this.selectedHour}:${this.selectedMinute}`;
      if (!this.validSelectedTime(selectedTime))
        useAlert('❌  - ' + this.errorMessage);
      else {
        this.weekdayTimesList.push(selectedTime);
        this.emitUpdatedBookableTimes();
      }
    },
    removeSelectedTime(selectedTime) {
      this.weekdayTimesList = this.weekdayTimesList.filter(
        e => e !== selectedTime
      );
      this.emitUpdatedBookableTimes();
    },
    validSelectedTime(selectedTime) {
      // Function to compare the selected time with list of selectable times
      const validTime = (val, validList) => validList.some(e => e === val);
      if (
        !selectedTime.split(':')[0] ||
        !selectedTime.split(':')[1] ||
        !validTime(this.selectedHour, this.selectableHours) ||
        !validTime(this.selectedMinute, this.selectableMinutes)
      ) {
        this.errorMessage = this.errorMessagesList[0];
        return false;
      }

      // Searching repeated times in the list
      if (this.weekdayTimesList.some(e => e === selectedTime)) {
        this.errorMessage = this.errorMessagesList[1];
        return false;
      }

      return true;
    },
    emitUpdatedBookableTimes() {
      const updatedBookableTimes = JSON.parse(
        JSON.stringify(this.bookableTimes)
      );
      updatedBookableTimes[this.currentWeekday].horarios =
        this.weekdayTimesList;

      this.$emit('updateCurrentBookableTimes', updatedBookableTimes);
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <select v-model="selectedHour" class="select-time text-sm">
        <option disabled value="">Hora</option>
        <option v-for="hour in selectableHours" :key="hour">
          {{ hour }}
        </option>
      </select>
      <select v-model="selectedMinute" class="select-time text-sm">
        <option disabled value="">Minuto</option>
        <option v-for="minute in selectableMinutes" :key="minute">
          {{ minute }}
        </option>
      </select>
      <button
        class="button default-style w-35"
        @click.prevent="addSelectedTime"
      >
        +
      </button>
    </div>

    <div v-for="(time, index) in weekdayTimesList" :key="time" class="row">
      <input
        class="text-black-900 default-style text-xs w-110"
        :class="{
          'grey-bg': index % 2 === 0,
        }"
        type="text"
        readonly
        :value="time"
        :style="{ color: index % 2 === 0 ? 'black' : '' }"
      />
      <button
        class="button default-style w-35 custom-bg-color"
        @click.prevent="removeSelectedTime(time)"
      >
        x
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.w-35 {
  width: 35px;
}
.w-110 {
  width: 110px;
}
.custom-bg-color {
  background-color: var(--r-700);
}
.select-time {
  width: 55px;
  height: 35px;
  border-radius: 0px;
  margin: 0;
}
.default-style {
  border: 0;
  height: 35px;
  border-radius: 0px;
  height: 35px;
  margin: 0;
}
input[readonly] {
  &:hover {
    cursor: pointer;
  }

  &.grey-bg {
    background-color: var(--b-100);
  }
}
button {
  box-shadow: 0px 1.5px 3px rgba(0, 0, 0, 0.486);
  transition: box-shadow 0.3s ease;
}
</style>
